import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import _debounce from 'lodash/debounce';
import classNames from 'classnames';
import { keyPress } from '../utils/key-press-utility';
import keyConstants from '../utils/keys-constants';
class Navbar extends Component {

    constructor(props) {

        super(props);
        this.state = {
            revealMore: false,
            visibleItemsMap: [...Object.keys(this.props.items)],
            hiddenItemsMap: [],
            offsetDropdown: 44,
        };
        this.items = this.props.items;
        this.navContainerRef = React.createRef();
        this.listRef = React.createRef();
        this.dropdownRef = React.createRef();
        this.itemsRefs = [];
        this._btnHandler = this._btnHandler.bind(this);
        this._docClickHandler = this._docClickHandler.bind(this);
        this._renderVisibleListItem = this._renderListItem.bind(this, false);
        this._renderHiddenListItem = this._renderListItem.bind(this, true);
        this._updateListItems = this._updateListItems.bind(this);
        this._keyPressHandler = this._keyPressHandler.bind(this);
        const {
            BACKSPACE,
            DEL,
            ESCAPE,
        } = keyConstants;
        const { downHandler, menuState } = keyPress(
            [
                BACKSPACE,
                DEL,
                ESCAPE,
            ],
            this.state.revealMore,
            this._keyPressHandler, {
                revealMore: false,
            });
        this.downHandler = downHandler;
        this.menuState = menuState;

    }

    componentDidMount() {

        if (this._isThereOverflow(_get(this.listRef, 'current'))) {

            this._updateListItems();

        }


        window.addEventListener('resize', _debounce(this._updateListItems, 250));
        document.addEventListener('click', this._docClickHandler, false);
        window.addEventListener('keydown', this.downHandler);

    }

    componentDidUpdate(prevProps, prevState) {

        if (this.state.revealMore !== prevState.revealMore) {
            this.menuState(this.state.revealMore);
        }
    }

    componentWillUnmount() {

        window.removeEventListener('resize', _debounce(this._updateListItems, 250));
        document.removeEventListener('click', this._docClickHandler, false);
        window.removeEventListener('keydown', this.downHandler);

    }

    _updateListItems() {

        const isSmallScreen = window.matchMedia("(max-width: 767px)").matches;
        const wrapperWidth = _get(this.listRef, 'current.offsetWidth', 0);
        const moreBtnWidth = _get(this.dropdownRef, 'current.offsetWidth', 0);
        let isSpaceAvailable = true;
        let availableSpace = wrapperWidth - moreBtnWidth;

        const visibilityReducer = ([
            visibleItemsMap,
            hiddenItemsMap,
        ], item, key, src) => {

            const itemWidth = this._getInlineElementWidth(item.current);

            // If it's the last iteration, we should not include the dropdown button in the available space.
            if (src.length - 1 === key) {

                availableSpace = availableSpace + moreBtnWidth;

            }

            if (isSpaceAvailable && (availableSpace - itemWidth) >= 0) {

                visibleItemsMap.push(key);
                availableSpace = availableSpace - itemWidth;

            } else {

                hiddenItemsMap.push(key);
                isSpaceAvailable = false;

            }
            return [
                visibleItemsMap,
                hiddenItemsMap,
            ];

        };

        const [
            visibleItemsMap,
            hiddenItemsMap,
        ] = this.itemsRefs.reduce(visibilityReducer, [
            [],
            [],
        ]);

        this.setState({
            isSmallScreen,
            visibleItemsMap,
            hiddenItemsMap,
        });

    }

    _getInlineElementWidth(item) {

        if (!item) {

            return 0;

        }

        const originalStyle = window && window.getComputedStyle ? window.getComputedStyle(item, null).display : '';
        let padding = 0;
        if (originalStyle !== 'inline-block') {

            item.style.display = 'inline-block';
            padding = window && window.getComputedStyle
                ? parseFloat(window.getComputedStyle(this.dropdownRef.current, null).paddingRight)
                : 30;

        }
        const itemWidth = item.offsetWidth + padding;
        item.style.display = originalStyle;

        return itemWidth;

    }

    _getOrCreateRef(id) {

        if (!this.itemsRefs.hasOwnProperty(id)) {

            this.itemsRefs[id] = React.createRef();

        }

        return this.itemsRefs[id];

    }

    _isThereOverflow(e) {

        return e ? e.offsetWidth < e.scrollWidth : false;

    }

    _btnHandler(event) {

        if (!event || (this.dropdownRef.current.firstChild !== event.target && event.target.tagName !== 'A')) {

            return;

        }

        const displayMenu = !this.state.revealMore;
        const topOffset = this.navContainerRef.current.getBoundingClientRect().bottom;

        if (this.state.isSmallScreen) {

            document.body.style.overflow = displayMenu ? 'hidden' : 'unset';

        }

        if (displayMenu) {

            // Just tracking the dropdown expansion
            this.props.onSubNavDropDownClick(event);

        }

        return this.setState({
            revealMore: displayMenu,
            offsetDropdown: topOffset,
        });

    }

    _docClickHandler(event) {

        if (this.dropdownRef.current.contains(event.target)) {

            return;

        }

        if (this.state.revealMore) {

            return this.setState({
                revealMore: false,
            });

        }

    }

    _keyPressHandler(updatedState) {

        this.dropdownRef.current.firstChild.focus();
        this.setState(updatedState);

    }

    _renderListItem(isHiddenElement, key) {

        const item = this.items[key];

        const {
            className,
            ...otherProps
        } = item.props;

        const classNames = className ? className.split(' ') : [];

        //Attach the analytics tracking to each item in the subNav
        const analyticsTracker = (e) => this.props.onSubNavItemClick(e, key);

        if (classNames.indexOf('navbar__link') === -1) {

            classNames.push('navbar__link');

        }

        const props = {
            className: classNames.join(' '),
            onClick: analyticsTracker,
            ...otherProps,
        };

        if(isHiddenElement && !this.state.revealMore) {

            props.tabIndex = -1;

        }

        const element = React.cloneElement(item, props);

        return (
            <li
                key={key}
                className="navbar__item"
                ref={this._getOrCreateRef(key)}
            >
                {element}
            </li>
        );

    }

    render() {

        const {
            searchComponent,
            dropdownLabel,
        } = this.props;
        const {
            visibleItemsMap,
            hiddenItemsMap,
            revealMore,
            offsetDropdown,
            isSmallScreen,
        } = this.state;
        const items = visibleItemsMap.map(this._renderVisibleListItem);
        const hiddenItems = hiddenItemsMap.map(this._renderHiddenListItem);
        const dropdownClass = classNames({
            'navbar__item': true,
            'navbar__dropdown': true,
            'navbar__dropdown--hidden': !hiddenItemsMap.length,
            'navbar__dropdown--active': revealMore,
        });
        const dropdownStyle = {
            height: isSmallScreen ? `calc(100vh - ${offsetDropdown}px)` : '100%',
        };

        return (
            <section className="navbar">
                <nav className="navbar__container" ref={this.navContainerRef}>
                    <ul className="navbar__items" ref={this.listRef}>
                        {items}
                        <li
                            className={dropdownClass}
                            ref={this.dropdownRef}
                            onClick={this._btnHandler}
                        >
                            <button
                                className="navbar__dropdown-btn"
                                aria-label="More channels"
                                aria-haspopup="true"
                                aria-pressed={this.state.revealMore}
                            >
                                {dropdownLabel}
                            </button>
                            <div className={`navbar__dropdown-items`} style={dropdownStyle}>
                                <ul className={`navbar__dropdown-columns`}>
                                    {hiddenItems}
                                </ul>
                            </div>
                        </li>
                    </ul>
                    {!!searchComponent && searchComponent}
                </nav>
            </section>
        );

    }

};

Navbar.propTypes = {
    searchComponent: PropTypes.object,
    items: PropTypes.arrayOf(PropTypes.node),
    dropdownLabel: PropTypes.string,
    onSubNavItemClick: PropTypes.func,
    onSubNavDropDownClick: PropTypes.func,
};

Navbar.defaultProps = {
    searchComponent: null,
    items: [],
    dropdownLabel: 'More Channels',
    onSubNavItemClick: () => null,
    onSubNavDropDownClick: () => null,
};

export default Navbar;
